module.exports = __webpack_public_path__ + "static/media/milky-way.45c573c0.jpg";